// import Button from 'src/components/atoms/Button'
import Logo from 'src/logos/Logo';
import InputWrap from 'src/components/molecules/InputWrap';
import css from './Login.module.scss';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import InputPassword from 'src/components/molecules/InputPassword';
import Checkbox from 'src/components/atoms/Checkbox';
import { setEmail, setStep, setToken } from 'src/slices/signup';
import Button from 'src/components/atoms/Button';

import { login, toggleDoCacheToken, getPersonalDetails, clearState } from 'src/slices/auth';
import { handleStatus } from 'src/slices/utils';
import { clearCurrentMarker } from 'src/slices/location';

export default function Auth() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, doCacheToken } = useSelector((state) => state.auth);
  const { email } = useSelector((state) => state.signup);

  const [loginCredentials, setLoginCredentials] = useState({
    email: email,
    password: '',
    type: 'merchant',
  });

  const handleLogin = (e) => {
    e?.preventDefault();

    dispatch(login(loginCredentials));
    dispatch(setStep(0));
    dispatch(clearCurrentMarker());
    dispatch(setEmail(''));
  };
  useEffect(() => {
    handleStatus(status.login, () => dispatch(clearState(status.login)), {
      isSuccess: {
        toast: false,
        callback: () => navigate('/home'),
      },
      isError: {
        callback: () => {
          if (status.login.message == 'INCOMPLETE_PROFILE') {
            // dispatch(clearState(status.login))
            // dispatch(setToken({ token, refreshToken, user }))
            dispatch(setStep(2));
            navigate('/signup');
          }
        },
        toast: status.login.message != 'INCOMPLETE_PROFILE',
      },
    });
  }, [status.login]);

  return (
    <>
      <div className={css['page']}>
        <form className={css['box']} onSubmit={(e) => handleLogin(e)}>
          <Logo width="260px" />

          <div className={css.component}>
            <h3 className={css.title}>Login</h3>
            <div className={css.inputs}>
              <InputWrap
                label="Email"
                component={
                  <input
                    value={loginCredentials.email}
                    onChange={(e) =>
                      setLoginCredentials({
                        ...loginCredentials,
                        email: e.target.value,
                      })
                    }
                    type="email"
                    autoFocus={!email}
                    onKeyPress={(e) => (e.key == 'Enter' ? handleLogin(e) : null)}
                  />
                }
              />
              <InputPassword
                forgetLink="/forgot-password"
                value={loginCredentials.password}
                onChange={(e) =>
                  setLoginCredentials({
                    ...loginCredentials,
                    password: e.target.value,
                  })
                }
                onKeyPress={(e) => (e.key == 'Enter' ? handleLogin(e) : null)}
                showForgot={true}
                autoFocus={email}
              />

              <Checkbox
                key="2"
                label="Remember Me"
                name="remember"
                value={doCacheToken}
                onChange={(e) => dispatch(toggleDoCacheToken(e.target.checked))}
              />
            </div>
            <div className={css['buttons']}>
              <Button
                label="Sign up"
                color="white"
                variant="tertiary"
                href="/signup"
                // action={() => dispatch(setStep(0))}
                // action={hanldelogin}
              />
              <Button
                label="login"
                color="white"
                variant={'primary'}
                state={status.login.isLoading ? 'disabled' : null}
                type="submit"
                // tabindex="-1"
                // action={hanldelogin}
              />
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
